<!-- 我的页面 -->
<template>
  <span>(剩余{{min}} : {{sec}})</span>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    time: {
      type: Number,
      value: "",
      observer: function(newValue) {}
    },
    orderId: {
      type: String,
      value: "",
      observer: function(newValue) {
        
        this.setData({
          orderId: newValue
        });
      }
    },
    index: {
      type: Number,
      value: "",
      observer: function(newValue) {}
    }
  },
  data() {
    // 这里存放数据
    return {
      min: "",
      sec: "",
      initTimes: 0,
      timeText: "",
      cur_index: null,
      new_order_id: ""
    };
  },
  detached: function() {
    //清除计时器
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    time: {
      immediate: true,
      handler(curVal, oldVal) {
        this.countdown();
      },
      deep: true //true 深度监听
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
  // 方法集合
  methods: {
    countdown() {
      var that = this;
      const end = this.time;
      const now = new Date().getTime();
      const msec = end - now;
      let min = parseInt((msec / 1000 / 60) % 60);
      let sec = parseInt((msec / 1000) % 60);
      this.min = min > 9 ? min : "0" + min;
      this.sec = sec > 9 ? sec : "0" + sec;
      if (min >= 0 && sec >= 0) {
        if (min == 0 && sec == 0) {
          // cur_index
          var orderinfo = {
            id: that.orderId,
            index: that.index
          };
          this.$emit("bindcallback", orderinfo);
          return;
        }
        setTimeout(() => {
          this.countdown();
        }, 1000);
      }
    }
  }
};
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
</style>



// WEBPACK FOOTER //
// src/components/common/countDown.vue